import { actions, paths } from 'src/constants';
import { MAX_PAGE_SIZE } from 'src/constants/common';

export default {
  getCollections: (page, pageSize = MAX_PAGE_SIZE) => ({
    [actions.API_CALL]: {
      types: [
        actions.REPLENISHMENT_COLLECTIONS_GET_REQUEST,
        actions.REPLENISHMENT_COLLECTIONS_GET_SUCCESS,
        actions.REPLENISHMENT_COLLECTIONS_GET_FAILURE,
      ],
      promise: (client) =>
        client.get(paths.api.REPLENISHMENT, {
          params: {
            page,
            pageSize,
          },
        }),
    },
  }),
  getLevelsByCollectionId: (collectionId) => ({
    [actions.API_CALL]: {
      types: [
        actions.REPLENISHMENT_LEVELS_GET_REQUEST,
        actions.REPLENISHMENT_LEVELS_GET_SUCCESS,
        actions.REPLENISHMENT_LEVELS_GET_FAILURE,
      ],
      promise: (client) =>
        client.get(
          paths.build(
            paths.api.REPLENISHMENT_COLLECTIONS_ID_LEVELS,
            collectionId
          )
        ),
    },
  }),
};
